module.exports = __webpack_public_path__ + "static/media/DownloadBlue.ffd7ddc4.svg";